import { TextColor } from "@/components/typography/Typography"
import { Divider } from "antd"
import { DividerProps } from "antd/es/divider"
import classNames from "classnames"
import { FC } from "react"
import "./CustomDivider.less"

type Props = {
  marginTop?: number
  marginBottom?: number
  color?: TextColor
}
const CustomDivider: FC<Props & DividerProps> = ({
  color = "extra-light-gray",
  marginTop = 8,
  marginBottom = 8,
  children,
  ...rest
}) => {
  const classes = classNames("custom-divider", color)
  return (
    <Divider className={classes} style={{ marginTop, marginBottom }} {...rest}>
      {children}
    </Divider>
  )
}

export default CustomDivider
